import { render, staticRenderFns } from "./SalesPerWeek.vue?vue&type=template&id=e4f4561c&"
import script from "./SalesPerWeek.vue?vue&type=script&lang=js&"
export * from "./SalesPerWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports